// extracted by mini-css-extract-plugin
module.exports = {"termsAndConditionsWrapper":"data-collection_termsAndConditionsWrapper__0YB07","header":"data-collection_header__schjC","customContent":"data-collection_customContent__X4JZZ"};